import React, { createContext, useContext } from "react";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { getDummyImageSrc } from "repoV2/utils/common/render/images";
import { useSalePageContext } from "../SalePageContext";
import {
    FEATUREDIN_DEFAULT_VALUE,
    featured_in_preview_title,
} from "../constants";

type IFeaturedInSectionContextValue = {
    hide: boolean;
    title: string;
    featuredInList: Array<{ title: string; imgSrc: string }>;
};

const initialContextValue: IFeaturedInSectionContextValue = {
    hide: false,
    title: "",
    featuredInList: [],
};

const FeaturedInSectionContext = createContext(initialContextValue);

export function FeaturedInSectionContextProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { sectionsData, isPreview, basicData } = useSalePageContext();
    const templateSlug = basicData?.templateSlug;
    const defaultValue =
        featured_in_preview_title?.[templateSlug]?.customTitle ??
        FEATUREDIN_DEFAULT_VALUE.DEFAULT;
    const dummyData: IFeaturedInSectionContextValue["featuredInList"] =
        Array.from(Array(3)).map((x: any, i: number) => {
            const idx = i + 1;
            return {
                title: `&lt;${defaultValue} ${idx}&gt;`,
                imgSrc: getDummyImageSrc({
                    width: 400,
                    height: 100,
                    text: `${defaultValue} ${idx}`,
                }),
            };
        });

    const featuredInList =
        (isPreview &&
        checkIsArrayEmpty(sectionsData.featuredInSection.featuredInList)
            ? dummyData
            : sectionsData.featuredInSection.featuredInList) || [];

    const contextValue: IFeaturedInSectionContextValue = {
        hide: checkIsArrayEmpty(featuredInList),
        title:
            sectionsData.featuredInSection.title ||
            (isPreview ? "Featured in" : ""),
        featuredInList,
    };
    return (
        <FeaturedInSectionContext.Provider value={contextValue}>
            {children}
        </FeaturedInSectionContext.Provider>
    );
}

export function useFeaturedInSectionContext() {
    return useContext(FeaturedInSectionContext);
}
